import { render, staticRenderFns } from "./propulsionType.vue?vue&type=template&id=fdf37c64&"
import script from "./propulsionType.vue?vue&type=script&lang=js&"
export * from "./propulsionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf37c64')) {
      api.createRecord('fdf37c64', component.options)
    } else {
      api.reload('fdf37c64', component.options)
    }
    module.hot.accept("./propulsionType.vue?vue&type=template&id=fdf37c64&", function () {
      api.rerender('fdf37c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/propulsionType.vue"
export default component.exports